import React, { useEffect, useState } from "react";
import ButtonComponent from "../../components/button";
import { ReactComponent as SuccessCircleFilledIcon } from "../../assets/icons/check-circle.svg";
import FcmNotificationPermissionPopup from "../../webview-components/fcm-notification-permission-popup";
import CopyAndShareLinksComponent from "../../webview-components/copy-and-share-links";
import { poolMoneyAgainForSomeone_extended } from "../../utils/global";

const PaymentSuccessfulDiv = ({ order_type, name, copyAndShareLinkUrl, id, shop, checkoutMethod, setScreenName, getOrderDetailsApiCall, setName, setStep, isUser_aLinkCreator, pageName }) => {
  const poolMoneyAgainForSelfSplit = () => {
    if(checkoutMethod === 'cart_based'){
      window.location.href = window.location.origin +"/checkout/"+ id;
    }
    else{
      localStorage.removeItem("payment_link__"+ id);
      
      setScreenName('payment');

      getOrderDetailsApiCall();
    }
  };

  const poolMoneyAgainForSomeone = () => {
    //setName("");
    //poolMoneyAgainForSomeone_extended(id, checkoutMethod);

    if(checkoutMethod === 'cart_based'){
      //OBO name is pending-TODO here for cart case
      window.location.href = window.location.origin +"/checkout/"+ id;
    }
    else{
      //setStep(3);

      //here issue of 1 cent comes up, amount is not getting fetched from "get-order-status" API, need to re-call that API or refresh the page
      let link_url = window.location.href;
      if(link_url.indexOf('redirect_status') > -1){
        link_url = link_url.replace('redirect_status','r_s');
      }
      
      window.location.href = link_url +"&obo_ui=yes";
    }
  };

  return (
    <div className="text-center mb-4">
      <div className="payment-success-container success">
        <div className="success-icon mb-2">
          {<SuccessCircleFilledIcon />}
          {isUser_aLinkCreator === true && order_type === 'fixed_payforme' && 'Details successfully added'}
          {(isUser_aLinkCreator === false || order_type !== 'fixed_payforme') && 'Payment confirmed'}
        </div>
      </div>

      <div className="text-center mt-3">
        {order_type === 'variable_self' &&
          <>
            <p className="note mb-3">
              Keep stacking <b>{name}</b> 🥳
            </p>

            <ButtonComponent
            type="button"
            id="continue_stacking_btn"
            className="btn btn-primary btn-pool-shadow btn-pool-full"
            label="Add to stack & continue"
            size="md"
            variant="primary"
            onClick={poolMoneyAgainForSelfSplit}
            ></ButtonComponent>
          </>
        }
        {order_type !== 'variable_self' &&
          <>
            {isUser_aLinkCreator === true && order_type === 'fixed_payforme' &&
              <>
                <p className="note">
                  Thank you <b>{name}</b> 🥳, you've added delivery, shipping, and contact details to your Shopify order!
                </p>
              </>
            }
            {(isUser_aLinkCreator === false || order_type !== 'fixed_payforme') &&
              <>
                <p className="note">
                  Thank you <b>{name}</b> 🥳, you've successfully contributed your share!
                </p>
                {pageName !== 'shopify-payment' &&
                  <p className="note mt-2">
                    <a className="darkGrayColor" onClick={poolMoneyAgainForSomeone} id="pay-on-behalf-of-someone-link-button">Click here</a> if you wish to contribute again for someone.
                  </p>
                }
              </>
            }
          </>
        }
      </div>

      {order_type !== 'variable_self' &&
        <CopyAndShareLinksComponent order_type={order_type} link_url={copyAndShareLinkUrl} view_mode="inline"></CopyAndShareLinksComponent>
      }

      <FcmNotificationPermissionPopup id={id} shop={shop}></FcmNotificationPermissionPopup>
    </div>
  );
};

export default PaymentSuccessfulDiv;
